import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";

export default function Header (){
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <header> 
            <nav id="menubar" className="navbar navbar-default navbar-fixed-top" role="navigation">
                <div className="container">
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle" onClick={toggleMenu}>
                            <span className="sr-only">Toggle navigation</span> 
                            <span className="icon-bar"></span> <span className="icon-bar"></span>
                             <span className="icon-bar"></span>
                        </button>
                    </div>
                    <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="bruno-navbar-collapse">
                       <ul className="nav navbar-nav navbar-right">
                            <li><ScrollLink onClick={toggleMenu} activeClass="active" to="landing" spy={true} smooth={true} offset={-70} duration={500}>ACCUEIL</ScrollLink></li>
                            <li><ScrollLink onClick={toggleMenu} activeClass="active" to="presentation" spy={true} smooth={true} offset={-70} duration={500}>PRÉSENTATION</ScrollLink></li>
                            <li><ScrollLink onClick={toggleMenu} activeClass="active" to="magnetisme" spy={true} smooth={true} offset={-70} duration={500}>LE MAGNÉTISME</ScrollLink></li>
                            <li><ScrollLink onClick={toggleMenu} activeClass="active" to="contact" spy={true} smooth={true} offset={-70} duration={500}>CONTACTS</ScrollLink></li>
                            <li style={{paddingRight: '2em'}}><ScrollLink onClick={toggleMenu} activeClass="active" to="tarif" spy={true} smooth={true} offset={-70} duration={500}>TARIFS</ScrollLink></li>
  
                        </ul>
                    </div>
                </div>    
            </nav>
        </header>
    )
}
